// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-detail-container {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #1e293b;
  line-height: 1.8;
}

/* Breadcrumbs back transition */
nav a {
  transition: color 0.2s ease;
}

/* Header line heights */
.media-detail-container h1 {
  letter-spacing: -0.03em;
  font-weight: 900;
  color: #0f172a;
}

/* Typography styles for description */
article.prose p {
  color: #334155;
  font-size: 1.125rem;
  font-weight: 450;
  margin-bottom: 1.75rem;
  line-height: 1.9;
}

/* Rich HTML styling for prose content */
article.prose h2 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #0f172a;
  margin-top: 2.5rem;
  margin-bottom: 1.25rem;
  letter-spacing: -0.02em;
}

article.prose h3 {
  font-size: 1.35rem;
  font-weight: 750;
  color: #1e293b;
  margin-top: 2rem;
  margin-bottom: 1rem;
  letter-spacing: -0.01em;
}

article.prose ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

article.prose ol {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

article.prose li {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #475569;
  margin-bottom: 0.75rem;
  font-weight: 450;
}

article.prose blockquote {
  border-left: 4px solid #2563eb;
  padding: 1.25rem 1.5rem;
  font-style: italic;
  font-size: 1.2rem;
  color: #1e293b;
  margin: 2rem 0;
  background-color: #f8fafc;
  border-radius: 0 1rem 1rem 0;
  font-weight: 500;
  line-height: 1.8;
}

article.prose strong {
  color: #0f172a;
  font-weight: 700;
}

.rich-media-content img {
  border-radius: 1rem;
  margin: 2rem auto;
  max-width: 100%;
  height: auto;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

/* Social link hover animations */
.media-detail-container a[title^="Share"] {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.media-detail-container a[title^="Share"]:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

/* Sidebar lists group hover transition */
.group:hover img {
  transform: scale(1.05);
}

/* Page animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

main, aside {
  animation: fadeIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

/* Responsive constraints */
@media (max-width: 768px) {
  .media-detail-container h1 {
    font-size: 2.25rem;
  }
  
  .media-detail-container {
    padding-top: 5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MediaDetail.css"],"names":[],"mappings":"AAAA;EACE,uFAAuF;EACvF,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;;AAEA,iCAAiC;AACjC;EACE,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;EACvC,oFAAoF;AACtF;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".media-detail-container {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: #1e293b;\n  line-height: 1.8;\n}\n\n/* Breadcrumbs back transition */\nnav a {\n  transition: color 0.2s ease;\n}\n\n/* Header line heights */\n.media-detail-container h1 {\n  letter-spacing: -0.03em;\n  font-weight: 900;\n  color: #0f172a;\n}\n\n/* Typography styles for description */\narticle.prose p {\n  color: #334155;\n  font-size: 1.125rem;\n  font-weight: 450;\n  margin-bottom: 1.75rem;\n  line-height: 1.9;\n}\n\n/* Rich HTML styling for prose content */\narticle.prose h2 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #0f172a;\n  margin-top: 2.5rem;\n  margin-bottom: 1.25rem;\n  letter-spacing: -0.02em;\n}\n\narticle.prose h3 {\n  font-size: 1.35rem;\n  font-weight: 750;\n  color: #1e293b;\n  margin-top: 2rem;\n  margin-bottom: 1rem;\n  letter-spacing: -0.01em;\n}\n\narticle.prose ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n}\n\narticle.prose ol {\n  list-style-type: decimal;\n  padding-left: 1.5rem;\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n}\n\narticle.prose li {\n  font-size: 1.1rem;\n  line-height: 1.8;\n  color: #475569;\n  margin-bottom: 0.75rem;\n  font-weight: 450;\n}\n\narticle.prose blockquote {\n  border-left: 4px solid #2563eb;\n  padding: 1.25rem 1.5rem;\n  font-style: italic;\n  font-size: 1.2rem;\n  color: #1e293b;\n  margin: 2rem 0;\n  background-color: #f8fafc;\n  border-radius: 0 1rem 1rem 0;\n  font-weight: 500;\n  line-height: 1.8;\n}\n\narticle.prose strong {\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.rich-media-content img {\n  border-radius: 1rem;\n  margin: 2rem auto;\n  max-width: 100%;\n  height: auto;\n  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);\n}\n\n/* Social link hover animations */\n.media-detail-container a[title^=\"Share\"] {\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.media-detail-container a[title^=\"Share\"]:hover {\n  transform: translateY(-3px) scale(1.05);\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n/* Sidebar lists group hover transition */\n.group:hover img {\n  transform: scale(1.05);\n}\n\n/* Page animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(15px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\nmain, aside {\n  animation: fadeIn 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n/* Responsive constraints */\n@media (max-width: 768px) {\n  .media-detail-container h1 {\n    font-size: 2.25rem;\n  }\n  \n  .media-detail-container {\n    padding-top: 5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
